import { useCallback } from 'react';
import ListView from '../../../../components/ListView';
import { extractStageCandidates, getWorkflowStage } from '../../../../services/workflowApi';
import { synthesizeFieldsFromRows } from '../../../../services/responseMapping/mapListResponse';

function getRowKey(record) {
  return record.referenceId || record.applicantRefrenceId || record._id;
}

// getWorkflowStage returns { stageId, stageName, sequence, count, data: [...] }.
// extractStageCandidates pulls the candidate rows out of that shape; since the
// stage response carries no field config, fields are synthesized from the rows
// the same way mapListResponse does for module lists that omit `fields`.
function mapWorkflowStageResponse(stage) {
  const rows = extractStageCandidates(stage);

  return {
    rows,
    total: stage?.count ?? rows.length,
    tabs: [],
    fields: synthesizeFieldsFromRows(rows),
    tabField: '',
  };
}

// Shared list for every workflow-stage tab (Pipeline, Shortlisted, Submitted) under
// a job's Candidates section. workflowId is resolved once by CandidatesTab via
// getWorkflowByEntity(jobId); each tab only needs to say which stage it shows.
export default function WorkflowStageTab({ workflowId, stageName, actions = [], onCountChange }) {
  const fetchStage = useCallback(() => {
    if (!workflowId) return Promise.resolve({ data: [], count: 0 });

    return getWorkflowStage(workflowId, stageName)
      .then((stage) => {
        onCountChange?.(stage?.count ?? extractStageCandidates(stage).length);
        return stage;
      })
      .catch((err) => {
        console.error('[WorkflowStageTab] getWorkflowStage failed:', workflowId, stageName, err);
        throw err;
      });
  }, [workflowId, stageName, onCountChange]);

  return (
    <ListView
      moduleName="candidate"
      rowKey={getRowKey}
      actions={actions}
      fetchData={fetchStage}
      responseMapper={mapWorkflowStageResponse}
    />
  );
}
